import { render, staticRenderFns } from "./PromoCruise.vue?vue&type=template&id=720174b5&scoped=true"
import script from "./PromoCruise.vue?vue&type=script&lang=js"
export * from "./PromoCruise.vue?vue&type=script&lang=js"
import style0 from "./PromoCruise.vue?vue&type=style&index=0&id=720174b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720174b5",
  null
  
)

export default component.exports